import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  actionType: {
    defaultMessage: 'Action Type',
    description: 'thing to move',
    id: 'maovkd',
  },
  actionTypeInactive: {
    defaultMessage: 'This rule type is no longer supported under your plan. Please remove or update this selection.',
    description: 'Guidance for user to switch rule type because its not supported anymore',
    id: 'INchjI',
  },
});
